import Marquee from "react-fast-marquee";

const items = [
  "Let's spell greater S_CCESS with a new U",
  "The Breakthrough Innovators",
  "PAN India · Since 2012",
  "1000+ Assignments",
  "9 Lakh+ Lives Impacted",
  "98% Client Retention",
];

export default function EditorialMarquee() {
  return (
    <section className="relative py-16 border-y border-[#0A0A14]/12 bg-[#EDE6D2]" data-testid="marquee">
      <Marquee gradient={false} speed={40} pauseOnHover>
        {items.map((t, i) => (
          <span key={i} className="mx-16 flex items-center gap-16">
            <span className="font-display font-light text-5xl md:text-7xl tracking-tight text-[#0A0A14]/85 italic">
              {t}
            </span>
            <span className="w-2 h-2 rounded-full bg-[#1E1B4B]" />
          </span>
        ))}
      </Marquee>
    </section>
  );
}
